"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NAFinish = void 0;
var tslib_1 = require("tslib");
var index_1 = require("./index");
var inversify_1 = require("inversify");
var NAFinish = (function (_super) {
    tslib_1.__extends(NAFinish, _super);
    function NAFinish() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.strategy = "IMMEDIATE";
        _this.template = "play_won";
        return _this;
    }
    NAFinish.prototype.getI18NKey = function () {
        var _a;
        var score = this.social.me.scoreSession;
        if ((_a = this.data) === null || _a === void 0 ? void 0 : _a.isWon) {
            return score > 0 ? "play_won_0" : "play_won_1";
        }
        return score > 0 ? "play_won_2" : "play_won_3";
    };
    NAFinish = tslib_1.__decorate([
        (0, inversify_1.injectable)()
    ], NAFinish);
    return NAFinish;
}(index_1.NotificationAction));
exports.NAFinish = NAFinish;
//# sourceMappingURL=NAFinish.js.map